import React, { Component } from 'react';
import { Modal, Spin, Tabs, Button } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import BasicInfo from './BasicInfo';
import ResearcherInfo from './ResearcherInfo';
import SupervisionInfo from './SupervisionInfo';


const TabPane = Tabs.TabPane;
const Config = {
    BasicInfoUrl: API_URL.hospital.queryDetail,
    ResearcherInfoUrl: API_URL.hospital.queryRegisteredSpecialties,
    SupervisionInfoUrl: API_URL.hospital.querySupervisionInfo,
}

class InstitutionalFilingInfo extends Component {
    state = {
        visible: false,
        loading: false,
        panes: [],
        record: {},
        hospitalInstitutionsBasicInfo: {},
        activeKey: 'BasicInfo',
        pagination: {
            current: 1,
            pageSize: 10,
        },
    }

    show = (record, type) => {
        const tabs = [
            {
                tab:'机构基本信息',
                key:'BasicInfo',
            },
            {
                tab:'备案专业和主要研究者信息',
                key:'ResearcherInfo',
            },
        ];
        if (type === '02') {
            tabs.push(
                {
                    tab:'监督检查信息',
                    key:'SupervisionInfo',
                }
            )
        }
        
        this.setState({
            visible: true,
            panes: tabs,
            record,
            type,
        },() => {
            this.loadData();
        });
    }

    loadData = () => {
        const { pagination, activeKey, record } = this.state;
        const { current, pageSize } = pagination;
        const { companyId } = record;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: Config[`${activeKey}Url`],
            data: {
                offset: current,
                limit: pageSize,
                companyId,
            },
            dataType: 'json',
            doneResult: res => {
                const { hospitalInstitutionsBasicInfo, dataResult = {} } = res;
                const { datas, totalCount } = dataResult;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    hospitalInstitutionsBasicInfo,
                    pagination,
                });
            }
        };
        $.sendRequest(options);
    };

    hide = () => {
        this.setState({
            visible: false,
            loading: false,
            panes: [],
            record: {},
            hospitalInstitutionsBasicInfo: {},
            activeKey: 'BasicInfo',
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    }

    getContent = () => {
        const { activeKey, hospitalInstitutionsBasicInfo, data, pagination, type } = this.state;
        let content = '';
        switch (activeKey) {
            case 'BasicInfo':
                content = <BasicInfo 
                    type={type}
                    hospitalInstitutionsBasicInfo={hospitalInstitutionsBasicInfo}
                />;
                break;
            case 'ResearcherInfo':
                content = <ResearcherInfo 
                    type={type}
                    data={data} 
                    pagination={pagination} 
                    handleTableChange={this.handleTableChange}
                />;
                break;
            case 'SupervisionInfo':
                content = <SupervisionInfo  data={data} pagination={pagination} handleTableChange={this.handleTableChange}/>;
                break;
        }
        return content
    }

    handleTabChange = (activeKey) => {
        this.setState({ 
            activeKey,
            pagination: {
                current: 1,
                pageSize: 10,
            }
        },() => {
            this.loadData();
        });
    }

    handleTableChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    render() {
        const {  visible, loading, activeKey, panes } = this.state;
        return (
            <Modal
                title={'查看机构备案信息'}
                visible={visible}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="800px"
                bodyStyle={{ maxHeight: 600 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                    <Tabs
                        activeKey={activeKey}
                        onChange={this.handleTabChange}
                    >
                        {
                            (panes || []).map(el => {
                                const { key, tab } = el;
                                return (
                                    <TabPane
                                        key={key}
                                        tab={tab}
                                    >
                                        {this.getContent()}
                                    </TabPane>
                                );
                            })
                        }
                    </Tabs>
                </Spin>
            </Modal>
        )
    }
}

export default InstitutionalFilingInfo;


// WEBPACK FOOTER //
// ./src/components/hospital/filingInfo/components/InstitutionalFilingInfo.js